import { FormExtractorService } from '../../../shared/services/form-extractor.service';
import { LogService } from '../../../shared/services/log.service';
import { Validator } from '../../../shared/services/validator';
import { CTRL_NAME_EXTRACTOR } from '../ctrl.name.extractor';

export class CTRL_33 implements Validator {

	public static id = 'CTRL_33';
	private message = 'error.ctr_33';


	public LOG: LogService = new LogService(CTRL_33);
	public formExtractorService: FormExtractorService = new FormExtractorService();


	validate(form: any, map) {



		// vérifier si la règle est applicable sur mon formulaire
		const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_33.id + '_');


		if (rgs.length > 0) {
			for (const rg of rgs) {
				const ctrl = form.controls[rg];
				const melAdmEtTechWithStepId = map.get(ctrl.value.rgCtrls.melAdmEtTech);
				const melAdmOuTechAdmWithStepId = map.get(ctrl.value.rgCtrls.melAdmOuTechAdm);
				const melAdmOuTechTechWithStepId = map.get(ctrl.value.rgCtrls.melAdmOuTechTech);
				const melDocumentWithStepId = map.get(ctrl.value.rgCtrls.melDocument);
				const melEnvoiWithStepId = map.get(ctrl.value.rgCtrls.melEnvoi);
				const melRensWithStepId = map.get(ctrl.value.rgCtrls.melRens);
				const melAdmEtTechCtrl = form.controls[melAdmEtTechWithStepId];
				const melAdmOuTechAdmCtrl = form.controls[melAdmOuTechAdmWithStepId];
				const melAdmOuTechTechCtrl = form.controls[melAdmOuTechTechWithStepId];
				const melDocumentCtrl = form.controls[melDocumentWithStepId];
				const melEnvoiCtrl = form.controls[melEnvoiWithStepId];
				const melRensCtrl = form.controls[melRensWithStepId];

				const checkValue = [];
				checkValue.push(form.controls[map.get(melAdmEtTechCtrl)] ? this.containsAtAndDot(form.controls[map.get(melAdmEtTechCtrl)].value) : '');
				checkValue.push(form.controls[map.get(melAdmOuTechAdmCtrl)] ? this.containsAtAndDot(form.controls[map.get(melAdmOuTechAdmCtrl)].value) : '');
				checkValue.push(form.controls[map.get(melAdmOuTechTechCtrl)] ? this.containsAtAndDot(form.controls[map.get(melAdmOuTechTechCtrl)].value) : '');
				checkValue.push(form.controls[map.get(melDocumentCtrl)] ? this.containsAtAndDot(form.controls[map.get(melDocumentCtrl)].value) : '');
				checkValue.push(form.controls[map.get(melEnvoiCtrl)] ? this.containsAtAndDot(form.controls[map.get(melEnvoiCtrl)].value) : '');
				checkValue.push(form.controls[map.get(melRensCtrl)] ? this.containsAtAndDot(form.controls[map.get(melRensCtrl)].value) : '');

				if (checkValue.indexOf(true) === -1) {
					// placer le message d'erreur
					form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
				} else {
					form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };
				}
			}
		}
	}

	containsAtAndDot(value): boolean {
		return value ? (value.includes('@') && value.includes('.')) : false;
	}
}
